var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fpui-preview-lightbox-image"},[_c('div',{staticClass:"lightbox-image",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.src}})]),(_vm.loading)?_c('fp-loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }